export function docEntityNameWithCount(candidateName: string, names: { name?: string }[] = []) {
  const count = names.reduce((count, x) => (x.name?.startsWith(candidateName) ? count + 1 : count), 0);

  if (count > 0) {
    candidateName += ` ${count + 1}`;
  }

  // recurse for the case where there is already an entity with the suffixed name
  if (names.find((x) => x.name === candidateName) && count > 0) {
    // check if name ends with " N", where N is the number of names
    if (candidateName.match(/\s[0-9]+$/)) {
      names = names
        .filter((x) => x.name !== candidateName)
        // sort if name prop exists, otherwise leave elements in place
        .sort((a, b) => (a.name && b.name ? a.name.localeCompare(b.name) : 0));
      candidateName = candidateName.substring(0, candidateName.lastIndexOf(" "));
    }

    return docEntityNameWithCount(candidateName, names);
  }

  return candidateName;
}
